import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store'
import Argon from "./plugins/argon-kit";

Vue.config.productionTip = false;
Vue.use(Argon);

import {Button, Select, Option, Loading, Alert} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

// configure language
locale.use(lang)

Vue.component(Button.name, Button);
Vue.component(Select.name, Select);
Vue.component(Option.name, Option);
Vue.component(Alert.name, Alert);
Vue.use(Loading.directive);

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
